export default "__VITE_ASSET__2nLm1jW4__"